/* kitsters-wishlist.js - Wishlist page
   1. exposes the page flags custom.js reads at top-level execution time
   2. handles Add to Cart on the shared product card ([data-add-to-cart])
   3. makes the remove (×) control keyboard-operable

   Load order matters: this file is a plain `defer` script rendered inside
   sections/kitsters-wishlist.liquid, and custom.js is a `type="module"`
   script at the end of <body>. Both wait for parsing and then run in
   document order, so the flags below are set before custom.js reads them. */

/* ── 0. q-less visit belt ─────────────────────────────────────────────
   The wishlist page IS a search over the saved ids; a visit with no q at
   all (a bookmark, a link written before kitsters-wishlist-a synced it, a
   shared URL) renders the empty state whatever localStorage holds. Re-run
   the search with the real ids. Loop-impossible by construction: it fires
   only when q is entirely absent and ids exist, and its target always
   carries a non-empty q. replace(), not assign - Back must not bounce.
   Skipped in the theme editor, where a redirect fights the preview. */
(function () {
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    var params = new URLSearchParams(window.location.search);
    if (params.has('q')) return;
    var W = window.KitstersWishlist;
    if (!W) return;                     // element script blocked - empty state stands
    var ids = W.read();
    if (!ids.length) return;
    window.location.replace(W.searchUrl(ids));
  } catch (e) { /* URLSearchParams/storage blocked - empty state stands */ }
})();

/* ── 1. Page flags (replaces Kalles' inline script) ──────────────────── */
(function () {
  var dataEl = document.getElementById('kw-data');
  if (!dataEl) return;
  try {
    var d = JSON.parse(dataEl.textContent);
    window.isPageWishlist = d.isPageWishlist;
    window.isWishlistPerformed = d.isWishlistPerformed;
  } catch (e) {}
})();

(function () {
  'use strict';

  /* ── 2. Add to Cart ────────────────────────────────────────────────────
     Mirrors the handler the collection/home grids use so the shared card
     behaves identically everywhere (same states, same cart-drawer event). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart], [data-kw-atc]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId) return;

    var savedHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '&hellip;';

    /* KitstersCart owns the drawer contract (assets/kitsters-cart-bridge.js).
       This used to read a `section-id` ATTRIBUTE off the drawer and dispatch
       `cart:update` with {cartData, source:'product-form-component',
       actionAfterATC} -- the KALLES contract, ported from India and never
       adapted. Dawn's <cart-drawer> has neither the attribute nor the
       listener, so `sectionId` was always null and the first branch never
       ran; the `cart:reload` fallback below it dispatched an event NOTHING in
       this tree listens for, so it was equally dead. Net effect: the item was
       added, the drawer kept its page-load HTML, and only a page refresh
       showed it. Root CLAUDE.md §10.21 -- never hand-roll an ATC handler. */
    var payload = { items: [{ id: variantId, quantity: 1 }] };

    window.KitstersCart.addToCart(payload)
      .then(function () {
        btn.innerHTML = '<i class="ph ph-check" aria-hidden="true"></i> Added!';
        setTimeout(function () { btn.disabled = false; btn.innerHTML = savedHTML; }, 2000);
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = savedHTML; });
  });

  /* ── 3. Keyboard support for the remove (×) control ──────────────────
     <kitsters-wishlist> is a div-like custom element with role="button"; it only
     binds a click listener, so Enter/Space would otherwise do nothing. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var remove = e.target.closest && e.target.closest('.kw-item__remove');
    if (!remove) return;
    e.preventDefault();
    remove.click();
  });
})();
